import { CategoryStatus } from '../../../../__generated__/queries-web';

export const EVENT_AUTOCOMPLETE_LIST_HEADER_LABEL =
  "Liste d'évènements disponibles";
export const ARTICLE_ENHANCEMENT_EVENTS_TITLE = 'Évènements';
export const NO_ARTICLE_EVENT_SELECTED_TITLE = 'Aucun évènement de selectionné';
export const EVENT_SEARCH_BAR_PLACEHOLDER = 'Rechercher un évènement';

const INACTIVE_EVENT_STATUS_LABELS: Partial<Record<CategoryStatus, string>> = {
  [CategoryStatus.Archived]: 'Archivée',
  [CategoryStatus.Deleted]: 'Corbeille',
};

export const getInactiveEventStatusLabel = (
  status?: CategoryStatus | null,
): string | undefined =>
  status ? INACTIVE_EVENT_STATUS_LABELS[status] : undefined;
